import { shaderMaterial } from '@react-three/drei';
import { extend, useFrame } from '@react-three/fiber';
import { useRef } from 'react';
import * as THREE from 'three';

// Custom Shader Material
const GridMaterial = shaderMaterial(
  { time: 0, color: new THREE.Color(0xaa00ff) },
  `
    varying vec2 vUv;
    uniform float time;
  
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
    `,
  `
    varying vec2 vUv;
    uniform float time;
    uniform vec3 color;
  
    void main() {
      vec2 uv = vUv - vec2(0.5);
      float dist = length(uv);
  
      // Grid lines - animated concentric circles
      float rings = sin(40.0 * dist - time * 3.0) * 0.5 + 0.5;
      rings = smoothstep(0.45, 0.47, rings);
  
      // Radial glow effect with pulsing animation
      float glow = smoothstep(0.6, 0.1, dist) * (sin(time * 1.5) * 0.2 + 0.8);
  
      // Pulsing hex-like grid effect
      float angle = atan(uv.y, uv.x) * 10.0;
      float radialLines = mod(angle + time * 2.0, 3.1415) < 0.2 ? 1.0 : 0.0;
  
      // Combining effects
      vec3 neon = color * (rings + glow + radialLines);
  
      gl_FragColor = vec4(neon, (rings + glow) * 0.9);
    }
    `
);

extend({ GridMaterial });

export function NeonGrid() {
  const materialRef = useRef<any>();

  useFrame(({ clock }) => {
    if (materialRef.current) {
      materialRef.current.time = clock.getElapsedTime();
    }
  });

  return (
    <mesh rotation={[-2.1, 0, 0]} position={[0, -10, -8]}>
      <circleGeometry args={[13, 64]} />
      <gridMaterial ref={materialRef} />
    </mesh>
  );
}
